import { SeatedPassengers } from "@b2bportal/air-booking-api";

// Builds a per-type passenger count map for the post-booking CFAR offer request. Includes
// each withLapInfants pair's adult alongside the alone passengers, so the fare-paying adult
// accompanying an infant isn't dropped from the count.
export const buildCfarPostBookingPassengerCounts = (
  passengers: SeatedPassengers,
): { [key: string]: number } => {
  const { alone, withLapInfants } = passengers;
  const allSeated = [...alone, ...withLapInfants.map(({ adult }) => adult)];
  const passengerCounts = allSeated.reduce<{ [key: string]: number }>(
    (acc, p) => ({ ...acc, [p.type]: (acc[p.type] ?? 0) + 1 }),
    {},
  );
  if (withLapInfants.length > 0) {
    passengerCounts.INF = withLapInfants.length;
  }
  return passengerCounts;
};
